import { Button, Checkbox, Divider, Popover, Typography } from "antd";
import styles from "./custom-filter.module.css";
import { useState } from "react";
import { FilterOutlined } from "@ant-design/icons";
import SVGIcon from "../../constants/SVGIcon";

export function CustomFilter({ filterData, values, onChange, onResetFilter, width, height }) {
  const [open, setOpen] = useState(false);
  const hide = () => {
    setOpen(false);
  };

  const onChangeCheckBoxes = (id, values) => {
    onChange(id, values);
  };

  const handleOpenChange = (newOpen) => {
    setOpen(newOpen);
  };

  const getFilterCount = () => {
    let tempCount = 0;
    filterData?.map((e) => {
      const count = values[e?.id]?.length;
      tempCount = tempCount + count;
    });
    return tempCount;
  };

  const headerData = (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <p style={{ fontSize: 18 }}>Filter</p>
        <p
          onClick={() => {
            onResetFilter();
            hide();
          }}
          style={{
            fontSize: 14,
            color: "var(--primary-color)",
            cursor: "pointer",
          }}
        >
          Reset
        </p>
      </div>
      <Divider style={{ margin: 0 }} />
    </>
  );
  const content = (
    <div style={{ paddingLeft: 5, paddingRight: 5 }}>
      {filterData?.length &&
        filterData?.map((e, index) => {
          return (
            <div key={index} style={{ paddingBottom: 10 }}>
              <Typography style={{ fontSize: "16px", fontWeight: "500" }}>
                {e?.label}
              </Typography>
              <div style={{ paddingTop: 10 }}>
                <Checkbox.Group
                  onChange={(checkedValue) =>
                    onChangeCheckBoxes(e?.id, checkedValue)
                  }
                  value={values[e?.id]}
                  options={e?.data}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    fontSize: "14px",
                  }}
                />
              </div>
            </div>
          );
        })}
    </div>
  );

  return (
    <Popover
      width={width}
      content={content}
      placement="bottomRight"
      title={headerData}
      trigger="click"
      open={open}
      onOpenChange={handleOpenChange}
    >
      <Button
        icon={
          <SVGIcon
            name={"filter-icon"}
            width={"24"}
            height={"24"}
            className="anticon"
            stroke={"#667085"}
          />
        }
        style={{
          display: "flex",
          alignItems: "center",
          height: height || "40px",
          width: width || "106px",
        }}
        className={styles.filterButton}
      >
        <Typography>Filter</Typography>
        {getFilterCount() ? "(" + getFilterCount() + ")" : ""}
      </Button>
    </Popover>
  );
}

export default CustomFilter;
